
import { updateAppConfig } from '#app/config'
import { defuFn } from 'defu'

const inlineConfig = {
  "buildId": "17772e410a5ce7296f26320ed33904fc409f3edf",
  "nuxt": {
    "buildId": "3f38c611-c99c-4cf3-9ae4-94b8984cfd9d"
  }
}

// Vite - webpack is handled directly in #app/config
if (import.meta.hot) {
  import.meta.hot.accept((newModule) => {
    updateAppConfig(newModule.default)
  })
}



export default /*@__PURE__*/ defuFn(inlineConfig)
